<template>
  <section id="about">
    <v-card class="elevation-0">
      <v-card-title></v-card-title>
      <v-card-text></v-card-text>
      <v-container>
        <v-layout
          column
          wrap
          class="my-5"
          align-center
        >
          <v-flex xs12 sm4 class="my-3">
            <div class="text-xs-center">
              <h2 class="display-1 v-heading mb-3 font-weight-light">Ein Freund in Not</h2>
              <span class="subheading">
                So kannst Du helfen!
              </span>
            </div>
          </v-flex>
          <v-flex xs12>
            <v-container grid-list-xl>
              <v-layout row wrap align-center>
                <v-flex xs12 md4>
                  <v-card class="elevation-0 transparent">
                    <v-card-text class="text-xs-center">
                      <v-icon x-large class="text--lighten-2" color="#97BE0D">pets</v-icon>
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline text-xs-center">Unterstütze deinen Liebling</div>
                    </v-card-title>
                    <v-card-text class="text-xs-center">
                      Wir haben Tiere in den Tierheimen, die nicht vermittelt werden können.<br/>
                      Oder schwierige Projekte, die Langzeithilfe brauchen. Hier kannst Du Tieren in Not helfen.
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 md4>
                  <v-card class="elevation-0 transparent">
                    <v-card-text class="text-xs-center">
                      <v-icon x-large class="text--lighten-2" color="#97BE0D">mobile_friendly</v-icon>
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline">Einfach Online</div>
                    </v-card-title>
                    <v-card-text class="text-xs-center">
                      Suche Dir einen Freund auf Distanz oder ein Projekt aus,<br/>
                      benutze unsere Applikation und du bist den Tieren ganz nah.
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 md4>
                  <v-card class="elevation-0 transparent">
                    <v-card-text class="text-xs-center">
                      <v-icon x-large class="text--lighten-2" color="#97BE0D">euro_symbol</v-icon>
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline text-xs-center display-1">Ab 5$ im Monat</div>
                    </v-card-title>
                    <v-card-text class="text-xs-center">
                      Schon ab einem Euro bist Du dabei. Wähle deinen eigenen Betrag.<br>
                      Mit 5$, 10$ oder 20$ bist Du ein wertvoller Unterstützer der Tiere.
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </section>
</template>

<script>
  export default {
    name: 'GuestTalk',
  };
</script>

<style scoped>

</style>
